import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../services/translation.service';

@Pipe({
    name: 'translation',
    standalone: true
})
export class TranslationPipe implements PipeTransform {

    constructor(private translationService: TranslationService) {
    }

    transform(value: string, args: any): any {

        const path = value.split('.');

        let translation = this.translationService.getTranslation(args);
        path.forEach(value => {
            if (translation[value]) {
                translation = translation[value];
            } else {
                console.error(`Could not find translation ${value}`);
            }
        });

        return translation;
    }

}
